module.exports = __webpack_public_path__ + "img/search-new.91ec3d20.svg";